import React from 'react';
import './card-sec2-p2.css'
import pic28 from '../../assets/pic28.png'

const Cardsec2p2 = (props) => {
    return ( 
        <article className='card-sec2-p2'>
                <figure className='img-cont-card-sec2-p2'>
                    <img className='piccccsec2p2' src={props.img} alt={props.alt}></img>
                </figure>

                <article className='container-info-card-sec2-p2'>

                    <article className='text-cont-sec2-p2'>
                        <h1 className='header-sec2-p2'>{props.title}</h1>
                        <h3 className='category-sec2-p2'>{props.category}</h3>
                        <p className='para-sec2-p2'>{props.para}</p>
                    </article>

                    <div className='line-card-sec2-p2'></div>

                    <article className='last-part-card-sec2-p2'>
                        <article className='left-box-card-sec2-p2'>
                            <img src={pic28} alt='location'></img>
                            <h2 className='booth-num'>{props.booth}</h2>
                        </article>

                        <nav className='viewmore-sec2-p2'>
                            View More
                        </nav>

                    </article>
                </article>
        </article>
     );
}
 
export default Cardsec2p2;